// src/constants/programBudget.js

// Board of Education program Firestore doc IDs (used for "% of total BoE budget" calculations)
export const BOE_PROGRAM_DOC_IDS = [
  "0200",
  "0300",
  "0400",
  "0500",
  "0600",
  "0700",
  "0900",
  "1000",
  "1100",
  "1300",
  "1400",
  "1500",
  "1600",
  "1900",
  "2000",
  "2100",
  "2200",
  "2300",
  "2400",
  "2700",
  "2800",
  "3000",
  "3100",
  "3200",
  "3300",
  "3400",
  "3600",
];

// Sections that are treated as “money” blocks when summing totals.
export const MONEY_BLOCKS = [
  "Salaries",
  "Purchased Services",
  "Supplies / Materials",
  "Other",
];

/**
 * Board of Education programs metadata used for:
 * - determining which docs to load
 * - consistent labels in tables/charts
 *
 * NOTE: `key` is retained for backward compatibility with existing code
 * that derives docId via getDocIdFromProgramKey(key).
 */
export const PROGRAM_CONFIG = [
  { id: "p0200", key: "0200 ART", label: "0200 ART" },
  {
    id: "p0300",
    key: "0300 BASIC EDUCATION ( K - 6 )",
    label: "0300 BASIC EDUCATION (K-6)",
  },
  {
    id: "p0400",
    key: "0400 ENGLISH LANGUAGE ARTS & READING",
    label: "0400 ENGLISH LANGUAGE ARTS & READING",
  },
  { id: "p0500", key: "0500 MATHEMATICS", label: "0500 MATHEMATICS" },
  { id: "p0600", key: "0600 SCIENCE", label: "0600 SCIENCE" },
  {
    id: "p0700",
    key: "0700 HISTORY & SOCIAL SCIENCES",
    label: "0700 HISTORY & SOCIAL SCIENCES",
  },
  {
    id: "p0900",
    key: "0900 CAREER & TECHNICAL EDUCATION",
    label: "0900 CAREER & TECHNICAL EDUCATION",
  },
  {
    id: "p1000",
    key: "1000 COMMUNITY SERVICES",
    label: "1000 COMMUNITY SERVICES",
  },
  { id: "p1100", key: "1100 P.A.C.E.", label: "1100 P.A.C.E." },
  {
    id: "p1300",
    key: "1300 FOREIGN LANGUAGE & ELL",
    label: "1300 FOREIGN LANGUAGE & ELL",
  },
  {
    id: "p1400",
    key: "1400 SCHOOL COUNSELING",
    label: "1400 SCHOOL COUNSELING",
  },
  {
    id: "p1500",
    key: "1500 HEALTH & PHYSICAL EDUCATION",
    label: "1500 HEALTH & PHYSICAL EDUCATION",
  },
  { id: "p1600", key: "1600 HEALTH SERVICES", label: "1600 HEALTH SERVICES" },
  { id: "p1900", key: "1900 LIBRARY MEDIA", label: "1900 LIBRARY MEDIA" },
  { id: "p2000", key: "2000 MUSIC", label: "2000 MUSIC" },
  {
    id: "p2100",
    key: "2100 OPERATIONS & MAINTENANCE",
    label: "2100 OPERATIONS & MAINTENANCE",
  },
  { id: "p2200", key: "2200 UTILITIES", label: "2200 UTILITIES" },
  {
    id: "p2300",
    key: "2300 PROGRAM & STAFF DEVELOPMENT",
    label: "2300 PROGRAM & STAFF DEVELOPMENT",
  },
  { id: "p2400", key: "2400 TRANSPORTATION", label: "2400 TRANSPORTATION" },
  {
    id: "p2700",
    key: "2700 SPECIAL EDUCATION",
    label: "2700 SPECIAL EDUCATION",
  },
  {
    id: "p2800",
    key: "2800 ATHLETICS & CLUBS",
    label: "2800 ATHLETICS & CLUBS",
  },
  {
    id: "p3000",
    key: "3000 AGRISCIENCE & TECHNOLOGY",
    label: "3000 AGRISCIENCE & TECHNOLOGY",
  },
  {
    id: "p3100",
    key: "3100 ELEMENTARY EDUCATION",
    label: "3100 ELEMENTARY EDUCATION",
  },
  {
    id: "p3200",
    key: "3200 SECONDARY EDUCATION",
    label: "3200 SECONDARY EDUCATION",
  },
  {
    id: "p3300",
    key: "3300 SYSTEMWIDE SUPPORT",
    label: "3300 SYSTEMWIDE SUPPORT",
  },
  {
    id: "p3400",
    key: "3400 FRINGE BENEFITS & SUBSTITUTES",
    label: "3400 FRINGE BENEFITS & SUBSTITUTES",
  },
  {
    id: "p3600",
    key: "3600 TECHNOLOGY SUPPORT SERVICES",
    label: "3600 TECHNOLOGY SUPPORT SERVICES",
  },
];